import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, KeyRoundIcon } from 'lucide-react';
interface CredentialStatusRowProps {
  providerName: string;
  connected: boolean;
  onManage: () => void;
}
export function CredentialStatusRow({
  providerName,
  connected,
  onManage
}: CredentialStatusRowProps) {
  return <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-5 py-3.5 shadow-sm" data-id="element-35" data-mp="2bq86ffiem0t">
      <div className="flex flex-wrap items-center gap-2.5" data-id="element-36" data-mp="7bvsfajg968v">
        <KeyRoundIcon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-37" data-mp="c7t95hymkem6" />
        <span className="text-sm font-medium text-slate-800" data-id="element-38" data-mp="h7fmrsid7wvi">AUS credentials</span>
        {connected ? <span className="inline-flex items-center gap-1 text-sm font-medium text-emerald-700" data-id="element-39" data-mp="l9u58bi4gum9">
            <CheckCircle2Icon aria-hidden="true" className="h-4 w-4" data-id="element-40" data-mp="2j03sq9me8yez" />
            Connected
          </span> : <span className="inline-flex items-center gap-1 text-sm font-medium text-amber-700" data-id="element-41" data-mp="2n1p2hm3mswky">
            <AlertTriangleIcon aria-hidden="true" className="h-4 w-4" data-id="element-42" data-mp="11t1e7mmjyi9j" />
            Not connected
          </span>}
        <span className="text-sm text-slate-400" data-id="element-43" data-mp="x08a90ywrdyi">· {providerName}</span>
      </div>
      <button type="button" onClick={onManage} className="rounded-lg px-2 py-1 text-sm font-medium text-slate-600 underline-offset-2 transition-colors hover:text-slate-900 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900" data-id="element-44" data-mp="s37zwdv0zp1l">
        Manage credentials
      </button>
    </div>;
}